<template>
  <layout>
    <div slot="content">
      <i-card title="预约场次列表">
        <div slot="right-menu">
          <el-button type="success" size="medium" icon="el-icon-plus" @click="addPlays.showDialog = true">添加场次
          </el-button>
        </div>
        <div slot="content">
          <el-table v-loading="loading" :data="userList" :border="true">
            <el-table-column prop="play_name" label="场次名称"/>
            <el-table-column prop="play_time" label="场次时间"/>
            <el-table-column prop="meeting_point" label="汇合点"/>
            <el-table-column prop="guide_user_name" label="默认讲解员"/>
            <el-table-column label="场次状态" prop="status_name">
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="(scope.row.status & 1)===1">{{ scope.row.status_name }}
                </el-tag>
                <el-tag size="mini" type="danger" v-else>{{ scope.row.status_name }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="添加时间" prop="created_at"/>
            <el-table-column label="操作" width="300" fixed="right">
              <div slot-scope="scope" class="opt-container">
                <el-button size="mini" type="primary" @click="showPlays(scope.row)">编辑</el-button>
                <el-button size="mini" type="primary" @click="switchStatus(scope.row)">禁用/启用</el-button>
                <router-link :to="{name:'settings.booking.plays_daily_list',query:{play_id:scope.row.play_id}}">
                  <el-button size="mini" type="primary">场次管理</el-button>
                </router-link>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </i-card>
      <!--添加场次-->
      <el-dialog title="添加场次" :visible.sync="addPlays.showDialog" width="30%">
        <div>
          <el-form :model="addPlays.data" :rules="addPlays.rules" size="small" label-width="95px">
            <el-form-item label="场次名称" prop="play_name">
              <el-input required v-model="addPlays.data.play_name"></el-input>
            </el-form-item>
            <el-form-item label="场次时间" prop="play_time">
              <el-time-select value-format="HH:mm" :picker-options="{start: '08:00',step: '00:10',end: '20:30'}" style="width: 100%"
                              arrow-control v-model="addPlays.data.play_time" placeholder="请选择场次时间"/>
            </el-form-item>
            <el-form-item label="默认库存" prop="default_stock">
              <el-input required v-model="addPlays.data.default_stock"></el-input>
            </el-form-item>
            <el-form-item label="汇合点" prop="meeting_point">
              <el-input required v-model="addPlays.data.meeting_point"></el-input>
            </el-form-item>
            <el-form-item label="默认讲解员" prop="guide_user_id">
              <el-select v-model="addPlays.data.guide_user_id" placeholder="请选择" style="width: 100%">
                <el-option v-for="guideUser in guideList" :key="guideUser.user_id+'_user'" :disabled="guideUser.status !== 1" :label="guideUser.name+'('+guideUser.mobile+')'" :value="guideUser.user_id"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addPlays.showDialog = false">取 消</el-button>
          <el-button type="primary" :loading="postLoading" @click="doAddPlay">确 定</el-button>
        </div>
      </el-dialog>
      <!--编辑-->
      <el-dialog title="编辑场次" :visible.sync="editPlays.showDialog" width="30%">
        <div>
          <el-form :model="editPlays.data" :rules="editPlays.rules" size="small" label-width="95px">
            <el-form-item label="场次名称" prop="play_name">
              <el-input required v-model="editPlays.data.play_name"></el-input>
            </el-form-item>
            <el-form-item label="场次时间" prop="play_time">
              <el-time-select value-format="HH:mm" :picker-options="{start: '08:00',step: '00:10',end: '20:30'}" style="width: 100%"
                              arrow-control v-model="editPlays.data.play_time" placeholder="请选择场次时间"/>
            </el-form-item>
            <el-form-item label="默认库存" prop="default_stock">
              <el-input required v-model="editPlays.data.default_stock"></el-input>
            </el-form-item>
            <el-form-item label="汇合点" prop="meeting_point">
              <el-input required v-model="editPlays.data.meeting_point"></el-input>
            </el-form-item>
            <el-form-item label="默认讲解员" prop="guide_user_id">
              <el-select v-model="editPlays.data.guide_user_id" placeholder="请选择" style="width: 100%">
                <el-option v-for="guideUser in guideList" :key="guideUser.user_id+'_user'" :disabled="guideUser.status !== 1" :label="guideUser.name+'('+guideUser.mobile+')'" :value="guideUser.user_id"/>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editPlays.showDialog = false">取 消</el-button>
          <el-button type="primary" :loading="postLoading" @click="doEditPlay">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </layout>
</template>

<script>
export default {
  name: "user-list",
  data() {
    return {
      userList: [],
      loading: false,
      postLoading: false,
      guideList:[],
      //添加场次
      addPlays: {
        showDialog: false,
        data: {play_name: "", play_time: "08:00", default_stock: "", meeting_point: "", guide_user_id: ""},
        rules: {
          play_name: [
            {required: true, message: '请输入场次名称', trigger: 'blur'},
          ],
          play_time: [
            {required: true, message: '请选择场次时间', trigger: 'blur'},
          ],
          default_stock: [
            {required: true, message: '请输入默认库存', trigger: 'blur'},
          ],
          meeting_point: [
            {required: true, message: '请输入汇合点', trigger: 'blur'},
          ],
          guide_user_id: [
            {required: true, message: '请选择默认讲解员', trigger: 'blur'},
          ],
        }
      },
      //编辑场次
      editPlays: {
        showDialog: false,
        data: {play_name: "", play_time: "08:00", default_stock: "", meeting_point: "", guide_user_id: ""},
        rules: {
          play_name: [
            {required: true, message: '请输入场次名称', trigger: 'blur'},
          ],
          play_time: [
            {required: true, message: '请选择场次时间', trigger: 'blur'},
          ],
          default_stock: [
            {required: true, message: '请输入默认库存', trigger: 'blur'},
          ],
          meeting_point: [
            {required: true, message: '请输入汇合点', trigger: 'blur'},
          ],
          guide_user_id: [
            {required: true, message: '请选择默认讲解员', trigger: 'blur'},
          ],
        }
      },
    }
  },
  methods: {
    getPlayList: function () {
      this.loading = true;
      this.$http.request('playList', {}).then(res => {
        this.userList = res.data;
        this.loading = false;
      })
    },
    doAddPlay: function () {
      let _self = this;
      this.$http.request('addPlay', this.addPlays.data).then(res => {
        if (res.status === 'success') {
          _self.getPlayList();
          _self.addPlays.showDialog = false;
        }
      });
    },
    doEditPlay: function () {
      let _self = this;
      this.$http.request('editPlay', this.editPlays.data).then(res => {
        if (res.status === 'success') {
          _self.getPlayList();
          _self.editPlays.showDialog = false;
        }
      });
    },
    //确认禁用
    switchStatus: function (playInfo) {
      let newStatus = playInfo.status === 1 ? {status: 2, status_name: "禁用"} : {status: 1, status_name: "启用"};
      let _self = this;
      this.$confirm('确认' + newStatus.status_name + '吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.$http.request('switchPlayStatus',{play_id:playInfo.play_id,status:newStatus.status}).then(function (res){
          _self.$message({
            message: res.message, type: 'success',
          });
          _self.getPlayList();
        });

      });
    },
    showPlays:function (playInfo){
      this.editPlays.data = playInfo;
      this.editPlays.showDialog = true;
    },
    //初始化讲解员列表
    initGuideList:function (){
      let _self = this;
      this.$http.request('guideOptions').then(function (res){
        _self.guideList = res.data;
      })
    }
  },
  created: function () {
    this.getPlayList();
    this.initGuideList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/booking/plays-list.vue